<template>
  <div class="bm-field" :data-qa="dataQa">
    <label class="bm-field-label">{{ labelVal }}</label>
    <template v-if="tooltipVal">
      <bm-tooltip bottom>
        <template #activator="{ on }">
          <v-icon small v-on="on">info</v-icon>
        </template>

        <span>{{ tooltipVal }}</span>
      </bm-tooltip>
    </template>
    <div><slot /></div>
  </div>
</template>

<script lang="ts">
import BmTooltip from "@/components/controls/input/BmTooltip.vue";
import BmLabelled from "@/components/controls/input/mixins/BmLabelled";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BmReadOnlyField",
  components: { BmTooltip },
  inheritAttrs: false,
  mixins: [BmLabelled],
});
</script>

<style scoped lang="sass">
.v-tooltip
  margin-left: 5px
</style>
